// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const FETCH_USER_MENU = 'FETCH_USER_MENU'
export const SET_LOCALE = 'SET_LOCALE'
export const SET_USER_VERIFIED = 'SET_USER_VERIFIED'

// feedback.js
export const RESPONSE_MSG = 'RESPONSE_MSG'
export const CLEAR_MSG = 'CLEAR_MSG'
export const LOADING_ON = 'LOADING_ON'
export const LOADING_OFF = 'LOADING_OFF'


//enrollment.js
export const SET_ENROLLMENT_ID = 'SET_ENROLLMENT_ID'
export const SET_ENROLLMENT = 'SET_ENROLLMENT'
export const SET_ENROLLMENT_STUDENT = 'SET_ENROLLMENT_STUDENT'
export const CLEAR_ENROLLMENT_PROCESS = 'CLEAR_ENROLLMENT_PROCESS'
export const FETCH_SONS = 'FETCH_SONS'
export const FETCH_ENROLLMENT_DATA_DIGITAL_SIGN = 'FETCH_ENROLLMENT_DATA_DIGITAL_SIGN'
export const SET_EXTEMP = 'SET_EXTEMP'
export const SET_EXTEMP_DETAIL = 'SET_EXTEMP_DETAIL'
export const SET_EXTERNAL_PAYMENT = 'SET_EXTERNAL_PAYMENT'
export const SET_EXTERNAL_PAYMENT_DETAIL = 'SET_EXTERNAL_PAYMENT_DETAIL'
export const SET_ENROLLMENT_YEAR = 'SET_ENROLLMENT_YEAR'
export const SET_SIESA_RECEIPT = 'SET_SIESA_RECEIPT'
export const POSITIVE_BALANCE = 'POSITIVE_BALANCE'
export const FEE = 'FEE'
export const SET_PORTFOLIO = 'SET_PORTFOLIO'
export const SET_YEARLY_PAYMENT = 'SET_YEARLY_PAYMENT'
export const SET_STUDENTS_ACCESS = 'SET_STUDENTS_ACCESS'

//extracurriculares_register.js
export const SET_COURSES = 'SET_COURSES'
export const SET_RESERVATIONS = 'SET_RESERVATIONS'
export const SET_REGISTERED_COURSES = 'SET_REGISTERED_COURSES'
export const SET_COURSE_IN_REGISTER = 'SET_COURSE_IN_REGISTER'
export const SET_STUDENTS = 'SET_STUDENTS'
export const SET_STUDENT_IN_REGISTER = 'SET_STUDENT_IN_REGISTER'
export const SET_LOADING = 'SET_LOADING'
export const SET_REGISTERED_COURSES_SAVED = 'SET_REGISTERED_COURSES_SAVED'
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA'



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js